var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 22,
  cy: 33,
  rx: 8.5,
  ry: 2.5,
  fill: "#9fd8ef"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m7.5 31.5c3-9.5 26-9.5 29 0",
  fill: "none",
  stroke: "#d9c9a8",
  strokeWidth: 5.5,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m12.6 26.2 2 2.6",
  fill: "none",
  stroke: "#b8a37a",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m18.6 23.9 0.6 3.2",
  fill: "none",
  stroke: "#b8a37a",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m25.4 23.9-0.6 3.2",
  fill: "none",
  stroke: "#b8a37a",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m31.4 26.2-2 2.6",
  fill: "none",
  stroke: "#b8a37a",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 37.5,
  cy: 8.5,
  r: 6,
  fill: "#23967f"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m40.8 8.5a3.3 3.3 0 1 1-3.3-3.3",
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m37.3 3.5 3.2 1.7-3.2 1.7z",
  fill: "#ffffff"
});

function SvgRefillSpillSocks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefillSpillSocks);
export default __webpack_public_path__ + "static/media/refill-spill-socks.d3c60f889905270abdb81f4b060b0aa6.svg";
export { ForwardRef as ReactComponent };